import React, {Component} from 'react'
import {isEqual} from 'lodash'
import PropTypes from 'prop-types'
import {SearchToSelect} from "../../components/selector/SearchToSelect";
import * as usersApi from "./usersApi";
import {Username} from "./components/Username";
import {UserSelector} from "./UserSelector";
import userResolver from "./UserResolver";


export class WorkflowUserSelector extends Component {

  static propTypes = {
    selected: PropTypes.any,
    onSelected: PropTypes.func,
    getUserSearchParams: PropTypes.func,
    filterAvailableUsers: PropTypes.func,
    ...UserSelector.propTypes
  }

  //user may be "User" or "Assignee" shapes; if the latter, copy from former
  static renderUser(user) {
    const userResolved = user.firstName ? user :  userResolver.fetchOne(user.userId).user
    return <Username chipSize="sm" user={{...userResolved, userId: WorkflowUserSelector.getKey(userResolved)}}/>
  }


  static getSearchResults({
                            query, offset
                          }) {
    return usersApi.listWorkflowUsers({
      query, offset
    }).then(({users, hasMore}) => {
      return ({items: users, hasMore: hasMore})
    });
  }

  static getKey(user) {
    return user.id || user.userId
  }

  render() {
    return <SearchToSelect
      {...this.props}
      getSearchResults={(params) => {
        const {getUserSearchParams} = this.props;
        params = getUserSearchParams ? getUserSearchParams(params) : params;
        return WorkflowUserSelector.getSearchResults(params)
      }}
      getKey={WorkflowUserSelector.getKey}
      renderOption={this.props.renderOption || WorkflowUserSelector.renderUser}
    />
  }
}

export class WorkflowUserIdSelector extends Component {
  static propTypes = {
    selected: PropTypes.any,
    ...UserSelector.propTypes
  }

  render() {
    const {selected, ...props} = this.props

    return <WorkflowUserSelector
      {...props}

      selectByKey
      resolveSelection={userIds => userResolver.fetchPromise(userIds)}
      selected={selected}
      onSelected={(...args) => this.props.onSelected(...args)}
    />
  }
}